/**
 * Format price utility function that uses user's currency
 * @param {number} amount - The amount to format
 * @param {string} currency - The currency code (e.g., 'USD', 'NGN', 'EUR')
 * @returns {string} Formatted currency string
 */
export const formatPrice = (amount, currency = 'USD') => {
  return new Intl.NumberFormat('en-US', { 
    style: 'currency', 
    currency: currency, 
    currencySign: 'standard' 
  }).format(amount);
};

/**
 * Format price with user's currency from Redux state
 * @param {number} amount - The amount to format
 * @param {object} user - User object from Redux state
 * @returns {string} Formatted currency string using user's currency
 */
export const formatPriceWithUserCurrency = (amount, user) => {
  const userCurrency = user?.currency || 'USD';
  return formatPrice(amount, userCurrency);
};

export default formatPrice;
